import { render } from "./AdminLohn.vue?vue&type=template&id=92d4de16"
import script from "./AdminLohn.vue?vue&type=script&lang=js"
export * from "./AdminLohn.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__